var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1895 4.61474C14.4936 4.17709 15.1334 3.83007 15.7955 4.10723L21.2583 6.39399C21.8784 6.6536 22.1822 7.35726 21.9457 7.98664L20.7866 11.0721C20.5286 11.7588 19.7375 12.0768 19.076 11.7597L18.1716 11.3261V19.6055C18.1716 20.2959 17.6119 20.8555 16.9216 20.8555H12.3847H12.3604H11.6347H11.6104H7.07352C6.38317 20.8555 5.82352 20.2959 5.82352 19.6055V11.3261L4.91908 11.7597C4.25761 12.0768 3.46651 11.7588 3.20853 11.0721L2.04938 7.98664C1.81294 7.35726 2.11668 6.6536 2.73685 6.39399L8.19959 4.10723C8.86168 3.83007 9.50152 4.17709 9.8056 4.61474C10.0312 4.9394 10.3704 5.1833 10.7407 5.34763C11.1165 5.51438 11.4666 5.57349 11.6519 5.57349H12.3432C12.5285 5.57349 12.8786 5.51438 13.2544 5.34763C13.6248 5.1833 13.9639 4.9394 14.1895 4.61474ZM12.3432 7.07349H12.4019V7.07277C12.8156 7.06273 13.3462 6.94796 13.8628 6.71871C14.3849 6.48703 14.945 6.11518 15.3628 5.5522L20.4568 7.68463L19.4784 10.2891L18.462 9.80181C17.6322 9.404 16.6716 10.0088 16.6716 10.929V19.3555H12.3847H12.3604H11.6347H11.6104H7.32352V10.929C7.32352 10.0088 6.36288 9.404 5.53313 9.80181L4.51672 10.2891L3.53828 7.68463L8.63234 5.5522C9.05014 6.11518 9.61019 6.48703 10.1323 6.71871C10.649 6.94796 11.1795 7.06273 11.5932 7.07277V7.07349H11.6519H12.3432Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsWhite);
export default __webpack_public_path__ + "static/media/items_white.2ca561d1fcc7c58c0bfd1ff64ecb494a.svg";
export { ForwardRef as ReactComponent };